export function stripLabelId(label: string): string {
  return label.replace(/^[IVXLCDM0-9]+(?:\.[A-Za-z0-9]+)*\.?\s+/, "").trim() || label;
}
